import { render } from "./Dashboard.vue?vue&type=template&id=08cfc8bf&scoped=true"
import script from "../js/dashboard.js?vue&type=script&lang=js"
export * from "../js/dashboard.js?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=08cfc8bf&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cfc8bf"]])

export default __exports__